export default __webpack_public_path__ + "static/media/InsideHeart_01.74cdbfc8.png";